<template>
  <section class="mb-4" v-show="show">
    <div class="">
      <h6 class="fw-bold">
        {{ 'Payment information' | translate }}
      </h6>
    </div>
    <div class="card-container">
      <div class="row mb-2">
        <div class="col-12">
          <label for="payu-card-number" class="form-label small mb-0">
            <small>{{ 'Card Number' | translate }}</small>
          </label>
          <div
            type="text"
            class="payu-card-form form-control"
            ref="payu-card-number"
            id="payu-card-number"
          ></div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="card-details clearfix mb-2">
            <div class="expiration">
              <label for="payu-card-date" class="form-label small mb-0">
                <small>{{ 'Expiration Date' | translate }}</small>
              </label>
              <div
                type="text"
                class="payu-card-form form-control"
                ref="payu-card-date"
                id="payu-card-date"
              ></div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="cvv mb-2">
            <label for="payu-card-cvv" class="form-label small mb-0">
              <small>CVV</small>
            </label>
            <div
              type="text"
              class="payu-card-form form-control"
              ref="payu-card-cvv"
              id="payu-card-cvv"
            ></div>
          </div>
        </div>
      </div>
      <div><InputErrors name="cypher"></InputErrors></div>
    </div>
  </section>
</template>

<script>
import InputErrors from '~/app2/components/InputErrors.vue'

export default {
  components: {
    InputErrors,
  },
  data: () => ({
    optionsForms: {
      cardIcon: true,
      style: {
        basic: {
          fontColor: '#000000',
          fontSize: '14px',
          fontWeight: '400',
        },
        invalid: {
          fontColor: '#dc3545',
        },
      },
      placeholder: {
        number: '',
        date: 'MM/YY',
        cvv: '',
      },
      lang: 'pl',
    },
  }),
  computed: {
    selectedPlanPriceIsZero() {
      if (_.get(this.$store.getters.currentPlan, 'price') === 0) {
        return true
      }

      return false
    },
    show() {
      if (this.selectedPlanPriceIsZero) {
        return false
      }
      return true
    },
  },
  mounted() {
      this.initiatePayu()
      this.initiateSecureForms()
  },
  methods: {
    initiatePayu() {
      window.payu = PayU(payuid)
    },
    initiateSecureForms() {
      window.secureForms = window.payu.secureForms()

      window.cardNumber = window.secureForms.add('number', this.optionsForms)
      window.cardDate = window.secureForms.add('date', this.optionsForms)
      window.cardCvv = window.secureForms.add('cvv', this.optionsForms)

      if (
        document.getElementById('payu-card-number') &&
        document.getElementById('payu-card-date') &&
        document.getElementById('payu-card-cvv')
      ) {
        window.cardNumber.render('#payu-card-number')
        window.cardDate.render('#payu-card-date')
        window.cardCvv.render('#payu-card-cvv')
      }      
    },
  },
}
</script>

